module.exports = __webpack_public_path__ + "assets/img/footer5.2f3460b6.png";